/**
 * /tenants/$slug/passkeys — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  passkeysListSearchSchema,
  type PasskeysListSearch,
} from "@/features/passkeys/schemas";
import { fetchTenantPasskeys } from "@/features/passkeys/queries";
import { queryKeys } from "@/lib/query-keys";
import { PasskeysListPage } from "@/features/passkeys/pages/passkeys-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/passkeys/")({
  validateSearch: (raw: Record<string, unknown>): PasskeysListSearch =>
    passkeysListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) => {
    const tenant = (context as { tenant: { id: string } }).tenant;
    return context.queryClient.ensureQueryData({
      queryKey: queryKeys.passkeys.list(tenant.id, deps.search),
      queryFn: () => fetchTenantPasskeys(tenant.id, deps.search),
    });
  },
  component: PasskeysListPage,
});
